import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum LocationStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  RETIRED = 3,
}

export function getLocationStatii(): ISelectItem[] {
  return [
    { id: 1, label: 'Pending' },
    { id: 2, label: 'Active' },
    { id: 3, label: 'Retired' },
  ]
}

export const getLocationStatusByLabel = getItemByLabelFactory(getLocationStatii)
export const getLocationStatusById = getItemByIdFactory(getLocationStatii)
